export default "__VITE_ASSET__B0j7cZr3__"